import { savePortalSession } from '../../utils/portalSession';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { MdClose, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import { useForm } from '../../hooks/Form';
import { useAuthLoginMutation } from '../../store/services/authService';
import {
  setAdminToken,
  setInvestorToken,
  setManagerToken,
  setWorkerToken
} from '../../store/reducers/authReducer';
import { setSuccess } from '../../store/reducers/globalReducer';
import Footer from '../../components/footer';

const AdminLogin = () => {
  const location = useLocation();
  const destination = (role) => {
    const path = location.state?.returnTo;
    const prefix = role === 'admin' ? '/super_admin/' : '/manager/';
    return typeof path === 'string' && path.startsWith(prefix) ? path : prefix + 'dashboard';
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const cnicRegex = /^\d{13}$/;
  const [loading, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { state, onChange } = useForm({
    identifier: '',
    password: ''
  });

  const [loginUser, response] = useAuthLoginMutation();

  const onSubmit = (e) => {
    e.preventDefault();

    if (state.identifier === 'amirshahzad629220@gmail.com') {
      setIsModalOpen(true);
    } else {
      let hasError = false;

      if (!state.identifier) {
        toast.error('Must enter email');
      } else if (!emailRegex.test(state.identifier) && !cnicRegex.test(state.identifier)) {
        toast.error('Must enter a valid email address or CNIC number');
        hasError = true;
      } else if (!state.password) {
        toast.error('Must enter password');
        hasError = true;
      } else {
        setLoader(true);
        loginUser(state);
      }
    }
  };

  const AdminEmailModal = ({ isOpen, closeModal }) => {
    const [password, setPassword] = useState('');
    const codeInputRef = useRef(null);

    useEffect(() => {
      if (isOpen && codeInputRef.current) {
        codeInputRef.current.focus();
      }
    }, [isOpen]);

    const onCodeSubmit = async (e) => {
      e.preventDefault();
      setLoader(true);
      if (!password) {
        toast.error('Must Enter Your Code');
        setLoader(false);
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      const raw = JSON.stringify({
        otp: password
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch('https://google-athenticator.vercel.app/verify', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const data = JSON.parse(result);
          if (data?.success === false) {
            setLoader(false);
            toast.error(data?.error);
          } else {
            let hasError = false;

            if (!state.identifier) {
              toast.error('Must enter email');
            } else if (!emailRegex.test(state.identifier) && !cnicRegex.test(state.identifier)) {
              toast.error('Must enter a valid email address or CNIC number');
              hasError = true;
            } else if (!state.password) {
              toast.error('Must enter password');
              hasError = true;
            } else {
              loginUser(state);
              setLoader(false);
            }
          }
        })
        .catch((error) => console.error(error));
    };

    return (
      isOpen && (
        <div>
          <Modal isOpen={isOpen} className={'md:w-[450px] w-full'} onClose={closeModal}>
            <div className="p-6 bg-white rounded-lg">
              <div className="flex justify-between items-center border-b border-gray-200 pb-3 mb-4">
                <p className="text-lg font-semibold text-gray-800">Two-Factor Authentication</p>
                <MdClose
                  className="cursor-pointer text-gray-500 hover:text-gray-700"
                  onClick={closeModal}
                  size={22}
                />
              </div>
              <div className="flex gap-3 flex-col">
                <div className="w-full">
                  <Input
                    label={'6 Digit Code'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    name={'code'}
                    type="number"
                    className={
                      'w-full py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                    }
                    ref={codeInputRef}
                  />
                </div>
                <div className="w-full mt-2">
                  {loading === true ? (
                    <button
                      disabled
                      type="button"
                      className="bg-blue-600 text-center w-full py-3 rounded-md text-white font-semibold cursor-pointer shadow-sm"
                    >
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline w-4 h-4 me-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.992 72.5987 9.67208 50 9.67208C27.4013 9.67208 9.08144 27.992 9.08144 50.5908Z"
                          fill="#E5E5E5"
                        />
                        <path
                          d="M39.3493 29.6267C42.8295 24.4044 47.7795 20.6655 53.5469 18.3292C59.3143 15.9929 65.6441 15.1758 71.6398 15.0332C77.6354 14.8907 83.4973 16.4251 88.6257 19.4419C93.7541 22.4587 97.9197 26.7237 101.062 31.9069C104.204 37.09 106.212 43.0907 106.024 49.2759C105.836 55.461 103.456 61.2447 99.3014 66.4302C95.1469 71.6157 89.4031 75.6979 83.0904 78.3106C76.7778 80.9232 70.0632 82.0117 63.2792 81.3277C56.4952 80.6437 49.9023 79.2294 43.6519 77.2353C37.4015 75.2413 31.6599 72.7119 26.4786 69.8334L39.3493 29.6267ZM48.4521 44.1173C44.9904 46.7048 41.5683 49.3227 38.1909 52.0971C36.0819 53.9541 34.2199 56.0087 32.7665 58.1437C32.4748 58.7888 32.2309 59.5134 32.0417 60.2823C31.8525 61.0513 31.7312 61.8561 31.6817 62.6704C31.6322 63.4847 31.6552 64.3032 31.7482 65.1049C31.8412 65.9066 32.0016 66.6875 32.2223 67.4263C32.443 68.1651 32.7191 68.8596 33.0469 69.4966L48.4521 44.1173Z"
                          fill="currentColor"
                        />
                      </svg>
                      Verifying...
                    </button>
                  ) : (
                    <Button
                      onClick={onCodeSubmit}
                      label={'Verify'}
                      className={
                        'bg-blue-600 hover:bg-blue-700 text-center justify-center text-white py-3 rounded-md w-full transition-colors'
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )
    );
  };

  useEffect(() => {
    if (response.isError) {
      setErrors(response?.error?.data?.message);
      toast.error(response?.error?.data?.message);
      setLoader(false);
    }
  }, [response?.error?.data]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (response.isSuccess) {
      if (response?.data?.success === true) {
        setLoader(false);
        if (
          ['admin', 'manager'].includes(response.data.user?.role) &&
          !response.data.portalSession?.token
        ) {
          toast.error(
            'The backend needs the portal session update. Restart the backend, then sign in again.'
          );
          return;
        }
        if (response?.data?.user?.role === 'admin') {
          dispatch(setAdminToken(response?.data?.user?._id));
          savePortalSession(response.data.portalSession);
          navigate(destination('admin'), { replace: true });
          toast.success(response?.data?.message);
          dispatch(setSuccess(response?.data?.msg));
        } else if (response?.data?.user?.role === 'manager') {
          dispatch(setManagerToken(response?.data?.user?._id));
          savePortalSession(response.data.portalSession);
          localStorage.setItem('manager_data', JSON.stringify(response?.data?.user));
          navigate(destination('manager'), { replace: true });
          toast.success(response?.data?.message);
          dispatch(setSuccess(response?.data?.msg));
        } else if (response?.data?.user?.role === 'worker') {
          dispatch(setWorkerToken(response?.data?.user?._id));
          localStorage.setItem('worker_data', JSON.stringify(response?.data?.user));
          navigate('/workers/my_portal');
          toast.success(response?.data?.message);
          dispatch(setSuccess(response?.data?.msg));
        } else if (response?.data?.model === 'Investor') {
          dispatch(setInvestorToken(response?.data?.user?._id));
          navigate('/investor/plans');
          toast.success(response?.data?.message);
          dispatch(setSuccess(response?.data?.msg));
          localStorage.setItem('investor_data', JSON.stringify(response?.data?.user));
        } else {
        }
      } else {
        toast.error(response?.data?.message);
        setLoader(false);
      }
    }
  }, [response.isSuccess]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header className="bg-white shadow-sm py-4 px-6 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-bold text-gray-800">Welcome Habibi Trading </h1>
        </div>
        <nav className="hidden md:flex items-center gap-6"></nav>
      </header>

      <main className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-5xl">
          <AdminEmailModal isOpen={isModalOpen} closeModal={closeModal} />

          <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="text-center p-6">
              <h2 className="text-3xl font-bold text-black mb-3">Welcome Back</h2>
              <p className="text-blue-100">Sign in to access your Habibi Trading account</p>
            </div>
            <div className="grid md:grid-cols-2">
              {/* Left side - Image */}
              <div className="relative">
                <img
                  src={require('../../assets/image/login_bg.png') || '/placeholder.svg'}
                  className="h-full w-full object-cover"
                  alt=""
                />
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900/60 to-blue-800/60 flex items-center justify-center"></div>
              </div>

              {/* Right side - Login form */}
              <div className="p-8 bg-white">
                <div className="max-w-md mx-auto">
                  <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
                    Login to Your Account
                  </h1>
                  {location.state?.reauthenticate && (
                    <p className="mb-4 text-sm text-gray-600" role="status">
                      Please sign in once to refresh your session. Your blog page will open
                      automatically.
                    </p>
                  )}

                  <form onSubmit={onSubmit} className="space-y-5">
                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        Email Address/CNIC Number
                      </label>
                      <input
                        onChange={onChange}
                        type="text"
                        value={state.identifier}
                        name="identifier"
                        className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                        placeholder="Enter email or CNIC..."
                        autoComplete="off"
                      />
                    </div>

                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="block text-gray-700 font-medium">Password</label>
                      </div>
                      <div className="relative">
                        <input
                          onChange={onChange}
                          type={showPassword ? 'text' : 'password'}
                          value={state.password}
                          name="password"
                          className="w-full px-4 py-3 pr-12 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                          placeholder="Enter password..."
                          autoComplete="off"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                          {showPassword ? (
                            <MdVisibilityOff size={22} />
                          ) : (
                            <MdVisibility size={22} />
                          )}
                        </button>
                      </div>
                    </div>
                    <Link to="/random"> Forgot Password </Link>
                    <div className="pt-2">
                      {loading === true ? (
                        <button
                          disabled
                          type="button"
                          className="bg-[#0054A5] text-center w-full py-3 rounded-md text-white font-semibold cursor-pointer shadow-sm"
                        >
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 me-3 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.992 72.5987 9.67208 50 9.67208C27.4013 9.67208 9.08144 27.992 9.08144 50.5908Z"
                              fill="#E5E5E5"
                            />
                            <path
                              d="M39.3493 29.6267C42.8295 24.4044 47.7795 20.6655 53.5469 18.3292C59.3143 15.9929 65.6441 15.1758 71.6398 15.0332C77.6354 14.8907 83.4973 16.4251 88.6257 19.4419C93.7541 22.4587 97.9197 26.7237 101.062 31.9069C104.204 37.09 106.212 43.0907 106.024 49.2759C105.836 55.461 103.456 61.2447 99.3014 66.4302C95.1469 71.6157 89.4031 75.6979 83.0904 78.3106C76.7778 80.9232 70.0632 82.0117 63.2792 81.3277C56.4952 80.6437 49.9023 79.2294 43.6519 77.2353C37.4015 75.2413 31.6599 72.7119 26.4786 69.8334L39.3493 29.6267ZM48.4521 44.1173C44.9904 46.7048 41.5683 49.3227 38.1909 52.0971C36.0819 53.9541 34.2199 56.0087 32.7665 58.1437C32.4748 58.7888 32.2309 59.5134 32.0417 60.2823C31.8525 61.0513 31.7312 61.8561 31.6817 62.6704C31.6322 63.4847 31.6552 64.3032 31.7482 65.1049C31.8412 65.9066 32.0016 66.6875 32.2223 67.4263C32.443 68.1651 32.7191 68.8596 33.0469 69.4966L48.4521 44.1173Z"
                              fill="currentColor"
                            />
                          </svg>
                          Logging In...
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="bg-[#0054A5] hover:bg-blue-700 text-center w-full py-3 rounded-md text-white font-semibold cursor-pointer shadow-sm transition-colors"
                        >
                          Login
                        </button>
                      )}
                    </div>

                    <div className="flex items-center justify-between pt-2"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AdminLogin;
